const tokens = {
  colors: {
    bg: {
      base: {
        default: 'white',
        _dark: 'black.900',
      },
      overlay: {
        default: 'white.700',
        _dark: '#000000BF',
      },
      glass: {
        default: 'white.200',
        _dark: 'black.200',
      },
      modal: {
        default: 'white',
        _dark: 'gray.800',
      },
    },
    border: {
      light: {
        default: 'whiteAlpha.200',
        _dark: 'white.50',
      },
      strong: {
        default: 'blackAlpha.200',
        _dark: 'white.100',
      },
    },
    fonts: {
      primary: {
        default: 'black.900',
        _dark: 'white',
      },
    },
    gradient: {
      base: {
        default: 'white',
        _dark: 'black.900',
      },
      accent: {
        default:
          'linear-gradient(90deg, #351B52 0%, #381856 25%, #282E5A 50%, #251B40 75%, #282249 100%)',
        _dark:
          'linear-gradient(90deg, #351B52 0%, #381856 25%, #282E5A 50%, #251B40 75%, #282249 100%)',
      },
      'auth-layout': {
        default:
          'linear-gradient(180deg, rgba(23, 26, 29, 0) 25%, var(--chakra-colors-app-background) 75%)',
      },
      clear: {
        default: 'white',
        _dark: 'transparent',
      },
      light: {
        default: 'white',
        _dark: 'black.200',
      },
    },
    buttons: {
      primary: {
        bg: {
          default: 'purple.500',
          _dark: 'accent.500',
        },
        'bg-hover': {
          default: 'purple.600',
          _dark: 'accent.600',
        },
        'bg-disabled': {
          default: 'purple.500',
          _dark: 'accent.500',
        },
        font: {
          default: 'white',
          _dark: 'white',
        },
        border: {
          default: 'purple.500',
          _dark: 'white.100',
        },
      },
      underline: {
        font: {
          default: 'purple.500',
          _dark: 'secondary.500',
        },
        'font-hover': {
          default: 'purple.400',
          _dark: 'secondary.300',
        },
      },
      'social-auth': {
        bg: {
          default: 'whiteAlpha.200',
          _dark: 'white.50',
        },
        'bg-hover': {
          default: 'whiteAlpha.50',
          _dark: 'accent.600_20',
        },
        font: {
          default: 'black.900',
          _dark: 'white',
        },
        'font-disabled': {
          default: 'whiteAlpha.50',
          _dark: 'white.100',
        },
        border: {
          default: 'whiteAlpha.200',
          _dark: 'white.100',
        },
        'border-hover': {
          default: 'whiteAlpha.50',
          _dark: 'accent.600_20',
        },
        icon: {
          default: 'black.900',
          _dark: 'white.300',
        },
        'icon-hover': {
          default: 'black.900',
          _dark: 'white',
        },
        'icon-disabled': {
          default: 'whiteAlpha.50',
          _dark: 'white.100',
        },
        'bg-disabled': {
          default: 'whiteAlpha.200',
          _dark: '#252C37',
        },
      },
    },
    'glass-items': {
      bg: 'rgb(96 119 156 / 5%)',
      'bg-active': 'rgb(96 119 156 / 15%)',
      'bg-hover': 'accent.600_20',
      'bg-double-hover': 'accent.600_40',
      border: 'white.100',
      'border-hover': 'accent.600_20',
      'border-double-hover': 'accent.600_40',
      icon: 'white',
      'icon-hover': 'accent.500',
    },
    'date-picker': {
      bg: '#232A368C',
      text: 'white',
      'text-hover': 'accent.500',
      'item-bg': 'rgb(96 119 156 / 10%)',
      'item-bg-hover': 'accent.600_20',
      'item-border': 'white.100',
      'item-border-hover': 'accent.600_20',
      'selected-bg': 'black.700',
      'selected-middle': 'black.200',
      'selected-text': 'accent.500',
    },
    spinner: {
      bg: 'white.200',
      main: 'white',
    },
    switch: {
      bg: 'gray.300',
      'bg-selected': 'accent.600',
      icon: 'white',
      font: 'white',
    },
    input: {
      font: 'white',
      border: 'white.100',
      'border-filled': 'white',
      'border-hover': 'accent.600',
      'border-error': 'red.500',
      'border-success': 'green.500',
      'border-warning': 'yellow.500',
      'border-info': 'blue.500',
      icon: 'white',
    },
    'search-input': {
      bg: 'rgba(96, 119, 156, 0.05)',
      border: 'white.100',
      icon: 'white.500',
      text: 'white.500',
      'bg-hover': 'accent.600_20',
      'border-hover': 'accent.600_20',
      'icon-hover': 'white.500',
      'text-hover': 'white.500',
      'bg-hover-filled': 'accent.600_20',
      'border-hover-filled': 'accent.600_20',
      'icon-hover-filled': 'white',
      'text-hover-filled': 'white',
      'bg-active': 'accent.600_20',
      'border-active': 'accent.600',
      'icon-active': 'white',
      'text-active': 'white',
      'bg-filled': 'rgba(96, 119, 156, 0.15)',
      'border-filled': 'white.100',
      'icon-filled': 'white',
      'text-filled': 'white',
      'bg-disabled': 'rgba(96, 119, 156, 0.05)',
      'border-disabled': 'white.100',
      'icon-disabled': 'white.100',
      'text-disabled': 'white.100',
    },
    clipboard: {
      'icon-hover': {
        default: '#A855F7',
        _dark: '#A855F7',
      },
    },
    link: {
      font: 'accent.50',
      'font-hover': 'white',
      decoration: 'accent.500',
      'citation-bg': 'alternative.purple-20',
      'citation-bg-hover': 'accent.600_40',
    },
    'nav-item': {
      'bg-hover': 'gray.800',
      'bg-selected': 'gray.700',
      icon: 'white',
      font: 'white',
      'border-selected': 'border.light',
    },
    tabs: {
      font: 'white',
      'font-hover': 'accent.500',
      'font-selected': 'accent.500',
      'font-disabled': 'white.200',
      border: 'white.0',
      'border-hover': 'white.0',
      'border-selected': 'accent.500',
      counter: 'black.900',
      'counter-bg': 'white',
      'counter-bg-selected': 'accent.300',
      'counter-bg-disabled': 'white.200',
    },
    cards: {
      bg: {
        default: 'white',
        _dark: 'gray.800',
      },
      'bg-hover': {
        default: 'white.100',
        _dark: 'accent.600_10',
      },
    },
    time: {
      exceeded: 'red.400',
      saved: 'green.400',
      neutral: 'gold.400',
    },
    tags: {
      blue: {
        font: 'alternative.blue',
        bg: 'alternative.blue-20',
      },
      green: {
        font: 'alternative.green',
        bg: 'alternative.green-20',
      },
      gold: {
        font: 'alternative.gold',
        bg: 'alternative.gold-20',
      },
      purple: {
        font: 'alternative.purple',
        bg: 'alternative.purple-20',
      },
      red: {
        font: 'alternative.red',
        bg: 'alternative.red-20',
      },
    },
    toast: {
      purple: {
        bg: 'alternative.purple-20',
        border: 'alternative.purple-20',
        bgHover: 'alternative.purple-10',
        borderHover: 'alternative.purple-10',
      },
      green: {
        bg: 'alternative.green-20',
        border: 'alternative.green-20',
        bgHover: 'alternative.green-10',
        borderHover: 'alternative.green-10',
      },
      red: {
        bg: 'alternative.red-20',
        border: 'alternative.red-20',
        bgHover: 'alternative.red-10',
        borderHover: 'alternative.red-10',
      },
      gold: {
        bg: 'alternative.gold-20',
        border: 'alternative.gold-20',
        bgHover: 'alternative.gold-10',
        borderHover: 'alternative.gold-10',
      },
      blue: {
        bg: 'alternative.blue-20',
        border: 'alternative.blue-20',
        bgHover: 'alternative.blue-10',
        borderHover: 'alternative.blue-10',
      },
      iconBg: 'rgba(163, 121, 231, 0.10)',
    },
    'empty-state-background': {
      default: 'white',
      _dark: '#16181B',
    },
    'app-background': 'bg.base',
    'app-text': 'fonts.primary',
    'default-border-color': 'border.light',
    'avatar-border-color': {
      default: 'blackAlpha.200',
      _dark: 'black.900',
    },
    muted: {
      default: 'blackAlpha.600',
      _dark: 'whiteAlpha.600',
    },
    'sidebar-background': 'bg.base',
    'sidebar-border-color': {
      default: 'default-border-color',
    },
    'sidebar-text': {
      default: 'app-text',
    },
    'sidebar-muted': {
      default: 'muted',
    },
    'chakra-body-bg': 'app-background',
    'chakra-body-text': 'app-text',
    'chakra-border-color': 'default-border-color',
  },
  fontSizes: {
    '3xl': '36px',
    '2xl': '24px',
    xl: '20px',
    lg: '18px',
    md: '16px',
    sm: '14px',
    xs: '13px',
  },
};

export default tokens;
